import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { isFunction, isString } from '../utils/xp.v1'
import {WZ, WZUtils} from '../utils/wz.v2'
import { getBaseDir, isAppraiser, isLogin } from '../utils/app'

Vue.use(Router)

function scrollBehavior() {
  return {
    x: 0,
    y: 0
  }
}

const router = new Router({
  mode: /^https?:\/\//.test(location.href) ? 'history' : 'hash',
  base: getBaseDir(),
  routes,
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  // 未登录
  if(to.meta.isLogin && (!isLogin || !WZUtils.isLogined())) {
    WZ.go('login');
    next(false);
    return;
  }
  // 鉴定师权限
  if(to.name.indexOf('appraiser') !== -1 && !isAppraiser){
    next({path:'/'});
    return;
  }
  next();
});

router.afterEach(to => {
  const {
    meta
  } = to
  let title = meta && meta.title
  if (isFunction(title)) {
    const { params, query } = to
    title = title(params || {}, query || {})
  }
  if (isString(title)) {
    document.title = title
  }
})

export default router
